import React from 'preact';
import gake from '../../img/gake_new_lg.png';

export default props => (
  <div className="main-section">
    <div class="pane-home pane">
      <div class="content">
        <h1>Hi, I'm Gen</h1>
        <p>
          I'm a coder at heart who thrives in terminal windows and fell into a
          front-end dev position (and I'm loving it). My day to day work
          involves lots of Javascript, HTML5, CSS3, and some Java for running
          Selenium. I love solving problems by thinking out loud (around other
          people).
        </p>

        <p>
          I'm a perpetual hobby collecter, that is, I collect new hobbies. My
          current obsessions include:
        </p>
        <ul>
          <li>Aeropress - the best damn coffee</li>
          <li>
            Javascript - currently happy with React.js, playing with AWS Lambda
          </li>
          <li>Rubik's cube - 3x3 Best avg of 5: 24.32s</li>
        </ul>
      </div>
      <div class="side-image">
        <img src={gake} />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./client/components/page/About.jsx